import { render, staticRenderFns } from "./item-multi-select.vue?vue&type=template&id=53bb6cd4"
import script from "./item-multi-select.vue?vue&type=script&lang=js"
export * from "./item-multi-select.vue?vue&type=script&lang=js"
import style0 from "./item-multi-select.vue?vue&type=style&index=0&id=53bb6cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.23_cache-loader@4.1.0_webpack@4.47.0_webpack-cli@3.3_rzr6sqiw3iaxcjpfollk37er5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports